// rg-simulador-envio (bug-check 07-10-2026, I2): antes este código vivía en un <script> dentro de
// snippets/rg-simulador-envio.liquid. Si el cliente entraba con el carro vacío, el simulador no estaba en la página
// y ese script nunca corría; al agregar un producto, el carro lateral dibujaba el simulador SIN su código (los
// <script> que llegan por morph no se ejecutan) y quedaba en "Calculando…" para siempre. Ahora se carga siempre
// (layout/theme.liquid) y encuentra los simuladores nuevos con el observador compartido.
(function () {
  if (window.__rgEnvioSimBound) return;
  window.__rgEnvioSimBound = true;

  var base = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '') + '/cart';

  function formatear(monto) {
    return '$' + Math.round(Number(monto)).toLocaleString('es-CL');
  }

  function sondear(intento) {
    return fetch(base + '/async_shipping_rates.json', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var tarifas = (data && data.shipping_rates) || [];
        if (tarifas.length === 0 && intento < 5) {
          return new Promise(function (resolve) {
            setTimeout(resolve, 450);
          }).then(function () {
            return sondear(intento + 1);
          });
        }
        return tarifas;
      });
  }

  // rg (2026-09-16): pedido del usuario -- ademas de la linea propia del
  // simulador ("+ $X de envio estimado"), el desglose del total (en
  // cart-summary.liquid, dentro de cart-totals) tambien se llena con la
  // MISMA tarifa real recien calculada: "Envio: $X" y "Total con envio
  // estimado: $carrito + $X". Viven en otra parte del DOM (no son hijos
  // de [data-rg-envio-sim]), por eso se buscan sueltos con querySelector.
  //
  // rg (2026-09-16, ronda 2): la auditoria marco que buscar con
  // "document.querySelector" (singular) tomaria la PRIMERA coincidencia de
  // toda la pagina si alguna vez coexistieran dos carritos en pantalla
  // (cajon + /cart) -- hoy nunca pasa (header-actions.liquid excluye el
  // cajon cuando template.name == 'cart'), pero se acota igual a la seccion
  // de Shopify que contiene A ESTE simulador puntual, para que deje de
  // depender de esa regla externa.
  function actualizarDesglose(scope, envioPesos, sinTarifa) {
    var lineaEnvio = scope.querySelector('[data-rg-envio-desglose-monto]');
    var lineaTotal = scope.querySelector('[data-rg-total-con-envio]');
    var envuelto = scope.querySelector('[data-rg-total-con-envio-wrap]');
    if (!lineaEnvio && !lineaTotal) return;

    // rg (2026-10-02): el subtotal nuevo (pedido del usuario, para que no
    // se confunda con "Total con envio estimado") viene del lado del
    // servidor con el filtro "| money" de Shopify -- que en esta tienda
    // imprime coma como separador de miles ("$99,980"), distinto al punto
    // que usa este mismo script via toLocaleString('es-CL') para las 2
    // lineas de aca abajo ("$104.980"). Se reformatea aca con el MISMO
    // toLocaleString para que las 3 cifras de este bloque se vean
    // consistentes entre si (no se toca el filtro nativo "money" -- ese
    // formato lo define Admin > Configuracion > General y se usa en todo
    // el resto del sitio, fuera del alcance de este ajuste puntual).
    var lineaSubtotal = scope.querySelector('[data-rg-subtotal-sin-envio]');
    if (lineaSubtotal && envuelto) {
      var totalCentavosSubtotal = Number(envuelto.dataset.cartTotal) || 0;
      lineaSubtotal.textContent = formatear(totalCentavosSubtotal / 100);
    }

    if (sinTarifa) {
      if (lineaEnvio) lineaEnvio.textContent = 'Se confirma en el pago';
      if (lineaTotal) lineaTotal.textContent = 'Se confirma en el pago';
      return;
    }

    var totalCentavos = envuelto ? Number(envuelto.dataset.cartTotal) || 0 : 0;
    var envioCentavos = Math.round(Number(envioPesos) * 100);

    if (lineaEnvio) lineaEnvio.textContent = formatear(envioPesos);
    if (lineaTotal) lineaTotal.textContent = formatear((totalCentavos + envioCentavos) / 100);
  }

  function pedir(sim, region) {
    var monto = sim.querySelector('[data-rg-envio-sim-monto]');
    if (!monto) return;
    var scope = sim.closest('.shopify-section') || document;
    monto.textContent = 'Calculando…';
    monto.removeAttribute('data-tone');
    var lineaEnvioPrevia = scope.querySelector('[data-rg-envio-desglose-monto]');
    var lineaTotalPrevia = scope.querySelector('[data-rg-total-con-envio]');
    if (lineaEnvioPrevia) lineaEnvioPrevia.textContent = 'Calculando…';
    if (lineaTotalPrevia) lineaTotalPrevia.textContent = 'Calculando…';

    fetch(base + '/prepare_shipping_rates.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ shipping_address: { country: 'Chile', province: region, city: '', zip: '' } }),
    })
      .then(function () {
        return sondear(0);
      })
      .then(function (tarifas) {
        if (!tarifas.length) {
          monto.textContent = 'Envío calculado en la página de pago';
          monto.setAttribute('data-tone', 'error');
          actualizarDesglose(scope, 0, true);
          return;
        }
        var mas_barata = tarifas.reduce(function (a, b) {
          return Number(a.price) <= Number(b.price) ? a : b;
        });
        monto.textContent = '+ ' + formatear(mas_barata.price) + ' de envío estimado';
        actualizarDesglose(scope, mas_barata.price, false);
      })
      .catch(function () {
        monto.textContent = 'Envío calculado en la página de pago';
        monto.setAttribute('data-tone', 'error');
        actualizarDesglose(scope, 0, true);
      });
  }

  function preparar(sim) {
    var select = sim.querySelector('[data-rg-envio-sim-select]');
    if (!select || select.dataset.rgBound === 'true') return;
    select.dataset.rgBound = 'true';

    try {
      var guardado = localStorage.getItem('rgEnvioSimZona');
      if (guardado) select.value = guardado;
    } catch (e) {}

    select.addEventListener('change', function () {
      try {
        localStorage.setItem('rgEnvioSimZona', select.value);
      } catch (e) {}
      pedir(sim, select.value);
    });

    pedir(sim, select.value);
  }

  function revisar() {
    document.querySelectorAll('[data-rg-envio-sim]').forEach(preparar);
  }

  function arrancar() {
    revisar();
  // rg (2026-09-16): antes cada snippet de envio tenia su PROPIO
  // MutationObserver permanente sobre document.body -- 4 en total en el
  // tema, cada uno disparandose ante CUALQUIER cambio del DOM de toda la
  // pagina (hallazgo de rendimiento de la auditoria). Se consolida en un
  // unico observer compartido: el primer script en cargar lo crea, el
  // resto solo se suscribe -- funciona sin importar el orden de carga.
  if (!window.__rgObservarCambiosDom) {
    window.__rgDomWatchers = [];
    window.__rgObservarCambiosDom = function (fn) { window.__rgDomWatchers.push(fn); };
    new MutationObserver(function (mutaciones) {
      window.__rgDomWatchers.forEach(function (fn) { fn(mutaciones); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  window.__rgObservarCambiosDom(revisar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();

